import type { UsuarioSessao } from "../types/auth";
import { comPeriodoGlobal, type FiltroPeriodoGlobal } from "./filtroPeriodoGlobal";

export interface EscopoEmpresaSessao extends FiltroPeriodoGlobal {
  codOrganizacao: string | number;
  codEmpresa: string | number;
}

/**
 * Mantém a organização selecionada e alterna somente o escopo de empresa.
 * `codEmpresa = "todos"` significa todas as empresas da organização atual.
 */
export function filtroEscopoEmpresaSessao(usuario: UsuarioSessao | null): EscopoEmpresaSessao {
  return comPeriodoGlobal({
    codOrganizacao: usuario?.selectedCodOrg ?? usuario?.codOrg ?? "",
    codEmpresa: usuario?.codEmpresa ?? "todos",
  });
}
